// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__XoS-D","inputDescription":"styles_inputDescription__2kvYl"};